import "./CardContent.css";
export default function CardContent(props){
    return <div className={`item ${props.className??''}`}>
        {props.children}
    </div>
}